import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'react-bootstrap'
//api
import { getLanguages } from 'api/company'
//components
import AutoCompleteInput from './autoCompleteInput'

const SearchLanguage = ({
  onSelected,
  defaultValue = null,
  labelField = 'nombre',
  valueField = 'id',
  showLabel = '',
  isMulti = true,
  formatCustomLabel = false, }) => {
  const [selectedItems, setSelectedItems] = useState(null);
  const { t } = useTranslation(['backoffice']);

  useEffect(() => {
    if (defaultValue) {
      const newSelectedItem = Array.isArray(defaultValue)
        ? defaultValue.map((item) => ({
          label: item[labelField] || item.label,
          value: item[valueField] || item.value
        }))
        : [{
          label: defaultValue[labelField] || defaultValue.label,
          value: defaultValue[valueField] || defaultValue.value
        }];
      setSelectedItems(newSelectedItem);

    } else {
      setSelectedItems(null);
    }
  }, [defaultValue, labelField, valueField]);


  const onSearch = async (value) => {
    if (value.length > 1) {
      const response = await getLanguages({ nombre: value, page: 1, page_size: 10 });
      if (response.status === 200) {
        const languages = response.data;
        return languages?.map((language) => ({
          label: language[labelField],
          value: language[valueField],
        }));
      }
    }
    return [];
  };


  const formatOptionLabel = ({ label }) => {
    if (formatCustomLabel && label.includes('(')) {
      const title = label.split('(')[0];
      const description = label.split('(')[1]?.replace(')', '') || '';
      return <span><b>{title.trim()}</b> {description && `(${description})`}</span>;
    }
    return <span>{label}</span>;
  }

  return (
    <AutoCompleteInput
      label={showLabel}
      defaultValue={selectedItems || []}
      defaultOptions={selectedItems || []}
      onSelect={onSelected}
      onSearch={onSearch}
      placeholder={t('searchByLanguage')}
      isMulti={isMulti}
      formatOptionLabel={formatOptionLabel}
    />
  );
}


SearchLanguage.propTypes = {
  onSelected: PropTypes.func.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholder: PropTypes.string,
  labelField: PropTypes.string,
  valueField: PropTypes.string,
  showLabel: PropTypes.string,
  isMulti: PropTypes.bool,
  formatCustomLabel: PropTypes.bool,
};





export default SearchLanguage